import { useLazyQuery } from '@apollo/client'
import { Box, Spinner, Tooltip } from '@chakra-ui/react'
import { FileArrowDownIcon } from '@phosphor-icons/react'
import { GET_MONTHLY_REPORT } from 'queries/reportQueries'

const Report = () => {
    const [getReport, { loading }] = useLazyQuery(GET_MONTHLY_REPORT);

    const onDownload = async () => {
        const { data } = await getReport();
        const report = data.getMonthlyReport;

        const binaryString = atob(report.content);

        const bytes = new Uint8Array(binaryString.length);

        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob(
            [bytes],
            {
                type: 'text/csv;charset=utf-8'
            }
        );

        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;
        link.download = report.filename;

        document.body.appendChild(link);

        link.click();

        link.remove();

        URL.revokeObjectURL(url);
    }

    return (
        <Tooltip label={`Baixar relatório`}>
            <Box cursor="pointer" onClick={onDownload}>
                {
                    !loading ?
                        <FileArrowDownIcon weight="fill" size={22} color="#FFF" />
                        :
                        <Spinner size="sm" />
                }
            </Box>
        </Tooltip>
    )
}

export default Report